import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "header-item",
  class: "flex flex-row justify-between"
}
const _hoisted_2 = { class: "font-bold text-lg" }
const _hoisted_3 = { class: "text-[16px]" }
const _hoisted_4 = { id: "enunciated-item" }
const _hoisted_5 = {
  id: "answer-item",
  class: "flex flex-col gap-2"
}
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = {
  id: "explanation-item",
  class: "flex flex-col gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_SelectButton = _resolveComponent("SelectButton")!

  return (_openBlock(), _createElementBlock("main", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.form.items, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        id: "questions-true-false",
        class: "p-5 bg-white rounded-md shadow-sm border flex flex-col gap-6 mb-5",
        key: i
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, "Item " + _toDisplayString(_ctx.chooseLetter(i)) + "*", 1),
          (i > 0)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "btn btn-delete",
                onClick: ($event: any) => (_ctx.deleteItem(i))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-1",
                    name: "md-delete"
                  }),
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("question.items.delete")), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Textarea, {
            id: "question-input",
            autoResize: true,
            rows: "3",
            cols: "30",
            placeholder: _ctx.t('question.prompt.items.empty'),
            modelValue: _ctx.store.form.items[i].answerText,
            "onUpdate:modelValue": ($event: any) => ((_ctx.store.form.items[i].answerText) = $event),
            class: _normalizeClass(
            _ctx.store.v$.form.items.$each.$response.$errors[i].answerText
              ?.length !== 0 && _ctx.store.v$.form.$error
              ? 'p-invalid'
              : ''
          ),
            maxlength: 999
          }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "class"]),
          _createVNode(_component_Errors, {
            errors: _ctx.store.v$.form.items.$each.$response.$errors[i].answerText,
            actualLength: _ctx.store.form.items[i].answerText?.length,
            maxLength: 999
          }, {
            msg: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.store.v$.form.$error ? _ctx.t("validations.required") : ""), 1)
            ]),
            _: 2
          }, 1032, ["errors", "actualLength"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", { pt: "Resposta", en: "Response" })), 1),
          _createVNode(_component_SelectButton, {
            modelValue: _ctx.store.form.items[i].correctAnswer,
            "onUpdate:modelValue": ($event: any) => ((_ctx.store.form.items[i].correctAnswer) = $event),
            class: "custom-true-false",
            options: _ctx.options,
            optionLabel: "label",
            optionValue: "value"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", null, _toDisplayString(_ctx.t("question.prompt.items.description.title")), 1),
          _createVNode(_component_Textarea, {
            id: "question-input",
            autoResize: true,
            rows: "3",
            cols: "30",
            placeholder: _ctx.t('question.prompt.items.empty'),
            modelValue: _ctx.store.form.items[i].answerDescription,
            "onUpdate:modelValue": ($event: any) => ((_ctx.store.form.items[i].answerDescription) = $event),
            class: _normalizeClass(
            _ctx.store.v$.form.items.$each.$response.$errors[i].answerDescription
              ?.length !== 0 && _ctx.store.v$.form.$error
              ? 'p-invalid'
              : ''
          ),
            maxlength: 999
          }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "class"]),
          _createVNode(_component_Errors, {
            errors: 
            _ctx.store.v$.form.items.$each.$response.$errors[i].answerDescription
          ,
            actualLength: _ctx.store.form.items[i].answerDescription?.length,
            maxLength: 999
          }, {
            msg: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.store.v$.form.$error ? _ctx.t("validations.required") : ""), 1)
            ]),
            _: 2
          }, 1032, ["errors", "actualLength"])
        ])
      ]))
    }), 128)),
    (_ctx.canAddItem)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          class: "btn btn-outline",
          label: _ctx.t('question.items.create'),
          icon: "pi pi-plus",
          onClick: _ctx.addItem
        }, null, 8, ["label", "onClick"]))
      : _createCommentVNode("", true)
  ]))
}